<!--
 * @Name: Email
 * @Description: 多邮箱配置
 * @Author: xiadongxue
 * @Date: 2022-07-19 10:15:42
 * @Editors: xiadongxue
-->
<template>
<div
    class="email-wrap"
    v-loading="loading">
    <div class="header-icon">
        <div
            class="click-icon add_icon"
            @click="visible = true"></div>
        <div
            class="click-icon refresh_icon"
            @click="refresh"></div>
    </div>
    <el-table
        :data="list"
        style="width: 100%"
        stripe
        border>
        <el-table-column
            v-for="item in tableColumn"
            :key="item.prop"
            align="center"
            :prop="item.prop"
            :label="item.label">
            <template v-slot="{row}">
                <template v-if="item.prop === 'enabled'">
                    {{row[item.prop] === 1 ? '开启' : '关闭'}}
                </template>
                <template v-else>{{row[item.prop]}}</template>
            </template>
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            width="120">
            <template v-slot="{row}">
                <el-button
                    type="text"
                    @click="toEditEmail(row)">编辑</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog
        v-loading="loading"
        title="邮箱配置"
        :visible.sync="visible"
        :modal-append-to-body="false"
        width="500px"
        @close="close">
        <el-form
            label-width="90px"
            ref="form"
            :model="emailData"
            :rules="emailRules">
            <el-form-item
                prop="emailSuffix"
                label="邮箱后缀">
                <el-input
                    size="small"
                    v-model="emailData.emailSuffix" />
            </el-form-item>
            <el-form-item
                prop="description"
                label="描述">
                <el-input
                    v-model="emailData.description"
                    size="small" />
            </el-form-item>
            <el-form-item
                prop="enabled"
                label="状态">
                <el-radio-group v-model="emailData.enabled">
                    <el-radio :label="0">关闭</el-radio>
                    <el-radio :label="1">开启</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="visible = false"
                size="small">取消</el-button>
            <el-button
                size="small"
                @click="submit"
                type="danger">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {
    emailList,
    updateEmail
} from './api';
export default {
    name: 'emailList',
    data() {
        return {
            loading: false,
            visible: false,
            //编辑数据
            emailData: {
                emailSuffix: '',
                description: '',
                enabled: 0
            },
            //表格数据
            list: [],
            tableColumn: [{
                prop: 'id',
                label: 'ID'
            }, {
                prop: 'emailSuffix',
                label: '邮箱后缀'
            }, {
                prop: 'description',
                label: '配置描述'
            }, {
                prop: 'enabled',
                label: '状态'
            }],
            emailRules: {
                emailSuffix: [{
                    required: true,
                    message: '请输入'
                },{
                    message: '请输入正确格式的邮箱后缀',
                    pattern: /@\w+([-.]\w+)*\.\w+([-.]\w+)*/
                }],
                description: [{
                    required: true,
                    message: '请输入'
                }]
            }
        }
    },
    created() {
        this.toSearch()
    },
    methods: {
        //点击查询
        async toSearch() {
            try {
                this.loading = true
                let {
                    code,
                    result
                } = await emailList()
                if (code === 0) {
                    this.list = result
                }
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        //重置
        refresh() {
            this.toSearch()
        },
        //编辑
        toEditEmail(row) {
            this.emailData = Object.assign({},row)
            this.visible = true
        },
        close() {
            this.emailData = {
                emailSuffix: '',
                description: '',
                enabled: 0
            }
            this.$nextTick(this.$refs['form'].clearValidate)
        },
        //提交
        submit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    //通过校验
                    this.toSave()
                } else {
                    return false
                }
            });
        },
        //保存
        async toSave() {
            try {
                this.loading = true
                let data = {
                    emailSuffix: this.emailData.emailSuffix,
                    description: this.emailData.description,
                    enabled: this.emailData.enabled
                };
                if (this.emailData.id) {
                    data.id = this.emailData.id
                }
                let {
                    code
                } = await updateEmail(data)
                if (code === 0) {
                    this.$message.success(`${!this.emailData.id ? '添加' : '修改'}成功`)
                    this.toSearch()
                    this.visible = false
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        },
    }
}
</script>

